import { LoadingTheme } from "@acin.reactjs/acin-ui/loading";
import { ComponentCSSStyle } from "@acin.reactjs/acin-ui/theme";

const loadingTheme = (): ComponentCSSStyle<LoadingTheme> => ({
  loading: {
    marginLeft: "0px",
  },
});

export default loadingTheme;
